// ** MUI Imports
import Card from '@mui/material/Card'
import { useTheme } from '@mui/material/styles'
import CardContent from '@mui/material/CardContent'

// ** Component Import
import { useEffect, useState } from 'react'
import _ from 'lodash'
import ReactApexcharts from 'react-apexcharts'
import { formatNumber } from '../../common/commonFunctions'

interface PieChartProps {
  title: string
  chartInfo: {
    labels: any[]
    values: any[]
    legendPosition:string
  }
}

const PieChart = (props: PieChartProps) => {
  // ** Hook
  const theme = useTheme()
  const [chartData, setChartInfo] = useState<any>({
    options: {},
    values: []
  })

  const { chartInfo, title } = props
  useEffect(() => {
    try{
      if (chartInfo && _.isArray(chartInfo.labels) && _.isArray(chartInfo.values))
        setChartInfo({
          options: {
            theme: {
              mode: theme.palette.mode
            },
            stroke: { width: 0 },
            labels: chartInfo ? chartInfo?.labels : [],
            dataLabels: {
              enabled: true,
              formatter: (val: string) => `${parseInt(val, 10)}%`
            },
            colors: [
              '#332288',
              '#6699CC',
              '#AA4499',
              '#117733',
              '#DDCC77',
              '#2C77FF',
              '#FF4560',
              '#546E7A',
              '#A300D6',
              '#43BCCD'
            ],
            chart: {
              height: 'auto',
              parentHeightOffset: 0
            },
            annotations: {
              yaxis: [
                {
                  padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                  }
                }
              ],
              xaxis: [
                {
                  padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                  }
                }
              ]
            },
            title: {
              text: title,
              align: 'left',
              margin: 30,
              offsetX: 0,
              offsetY: 0,
              paddingLeft: 1,
              floating: false,
              style: {
                fontSize: '1rem',
                fontWeight: '600',
                fontFamily: 'Cairo',
                justifyContent: "flex-start",
                color: "#1E355E"
              }
            },
            tooltip: {
              x: {
                show: false
              },
              y: {
                formatter: function (value: any) {
                  return formatNumber.format(parseInt(value))
                }
              }
            },
            legend: {
              position: chartInfo?.legendPosition??'right',
              itemMargin: {
                horizontal: 5,
                vertical: 5
              },
              offsetX: 0,
              offsetY: chartInfo?.legendPosition === 'bottom'?5:80,
              horizontalAlign: 'center',
              floating: false,
              markers: {
                width: 18,
                height: 18,
                strokeWidth: 0,
                strokeColor: '#fff',
                fillColors: undefined,
                radius: 18,
                customHTML: undefined,
                onClick: undefined,
                offsetX: 0,
                offsetY: 0
              }
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: false
                  }
                }
              }
            },
            grid: {
              padding: {
                top: 13,
                right: 0,
                bottom: 0,
                left: 0
              }
            }
          },
          values: chartInfo.values
        })
    }
    catch(err){
      console.log('error', err)
    }
  }, [chartInfo])

  return (
    <Card className='h-100 p-0'>
      <CardContent style={{ height: '95%' }} className='p-0'>
        <ReactApexcharts type='pie' height='100%' options={chartData.options} series={chartData.values} />
      </CardContent>
    </Card>
  )
}

export default PieChart
